import { render, staticRenderFns } from "./TopNabarProfile.vue?vue&type=template&id=3376d974&scoped=true&"
import script from "./TopNabarProfile.vue?vue&type=script&lang=js&"
export * from "./TopNabarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3376d974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3376d974')) {
      api.createRecord('3376d974', component.options)
    } else {
      api.reload('3376d974', component.options)
    }
    module.hot.accept("./TopNabarProfile.vue?vue&type=template&id=3376d974&scoped=true&", function () {
      api.rerender('3376d974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/partials/TopNabarProfile.vue"
export default component.exports